export default {
  label: {
    message: {
      error: {
        addEmail: 'Agregue algum email.',
        addAllEmails: 'Todos emails precisam ser validos.',
      },
    },
  },
};
